import {useMemo} from 'react'

import type {AddressPin} from '../../../../../../api/address'
import {routeDestinationPrefixName} from '../../../../lib/fieldNames'
import type {Contact, Route} from '../../../../types'

/** Параметры хука useRemovePointHandlers */
type Options = {
  /** Адреса маршрута */
  addresses: AddressPin[]
  /** Контакты */
  contacts: Contact[]
  /** Маршрут */
  route: Route
  /** Коллбэк на обновление маршрута и контактов */
  onUpdateRouteAndContacts: (route: Route, contacts: Contact[]) => void
}

/**
 * Создаёт хэндлеры, вызываемые при удалении точки.
 * @param route Точки маршрута
 */
export const useRemovePointHandlers = ({addresses, contacts, route, onUpdateRouteAndContacts}: Options) =>
  useMemo(
    () =>
      addresses.map((_, index) => () => {
        const routeShallowCopy = {...route}

        let contactsShallowCopy = [...contacts]

        // Смещаем все значения на i - 1, тем самым удаляя нужную точку
        for (let i = index; i < addresses.length; i++) {
          const currentDestination = `${routeDestinationPrefixName}${i}`
          const nextDestination = `${routeDestinationPrefixName}${i + 1}`

          routeShallowCopy[currentDestination] = routeShallowCopy[nextDestination] || undefined
          contactsShallowCopy[i] = contactsShallowCopy[i + 1] || undefined
        }

        delete routeShallowCopy[`${routeDestinationPrefixName}${addresses.length - 1}`]
        contactsShallowCopy = contactsShallowCopy.filter(Boolean)

        onUpdateRouteAndContacts(routeShallowCopy, contactsShallowCopy)
      }),
    [addresses, contacts, route, onUpdateRouteAndContacts],
  )
